import { render, staticRenderFns } from "./HoldDurationModal.vue?vue&type=template&id=a9c05806&"
import script from "./HoldDurationModal.vue?vue&type=script&lang=js&"
export * from "./HoldDurationModal.vue?vue&type=script&lang=js&"
import style0 from "./HoldDurationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports